export default __webpack_public_path__ + "static/media/4CISO.3b769f5c.png";